"use client"
/* */
import { jsx, Fragment } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { Option } from '../../../Option/Option.mjs';
import { useLocalizedStringFormatter } from 'react-aria';
import { flowComponent } from '../../../../lib/componentFactory/flowComponent.mjs';
import locales from '../../../../../../_virtual/_.locale.json@a75d4fdc8302dc8cc25be6a7eff37c38.mjs';

const countryCodes = Object.keys(locales["de-DE"]).filter((key) => key.startsWith("countries.")).map((key) => key.replace("countries.", ""));
const defaultSortBy = (left, right) => left.name.localeCompare(right.name);
const voidSortBy = () => 0;
const defaultFilterBy = () => true;
const CountryOptions = flowComponent(
  "CountryOptions",
  ({
    filterBy = defaultFilterBy,
    sortBy = voidSortBy
  }) => {
    const stringFormatter = useLocalizedStringFormatter(locales);
    const countries = useMemo(
      () => countryCodes.map((code) => ({
        code,
        name: stringFormatter.format(`countries.${code}`)
      })).filter(filterBy).sort(defaultSortBy).sort(sortBy),
      [stringFormatter, filterBy, sortBy]
    );
    return /* @__PURE__ */ jsx(Fragment, { children: countries.map((country) => /* @__PURE__ */ jsx(Option, { value: country.code, children: country.name }, country.code)) });
  }
);

export { CountryOptions, CountryOptions as default };
//# sourceMappingURL=CountryOptions.mjs.map
